import components from '../components';
import MotPresidentController from './mot-president.controller';
import MotPresidentTemplate from './mot-president.template.html';

components
  .component('motPresident', {
    bindings: {},
    controller: MotPresidentController,
    template: MotPresidentTemplate
  });



// WEBPACK FOOTER //
// ./src/app/components/mot-president/mot-president.component.js